export interface IConfig {
  pwa: {
    coki: {
      sameSite: "None" | "Strict";
      domain: string;
    };
    domain: string;
    port: string;
    prefixes: string[];
  };
  pwaPromptDelay: number;
  grid: {
    resolution: number;
    boundaryThreshold: number;
  };
  cdn: {
    baseUrl: string;
  };
  eta: {
    applicationReviewDays: number;
  };
  app: {
    name: string;
    version: string;
  };
  lambda: {
    baseUrl: string;
    retry: {
      maxRetries: number;
      initialDelayMs: number;
      maxDelayMs: number;
    };
  };
  mapsAPI: {
    nominatim: {
      baseUrl: string;
    };
    photon: {
      baseUrl: string;
    };
  };
  otpTimer: number;
  pages: {
    terms: string;
    policy: string;
  };
  env: string;
  support: {
    num: string;
    email: string;
    timing: {
      from: string;
      to: string;
    };
  };
  maps: {
    MAPBOX_TOKEN: string;
    MAPBOX_STYLE_URL: string;
    SEARCH_DEBOUNCE_DELAY: number;
    MIN_SEARCH_LENGTH: number;
    DEFAULT_COORDINATES: {
      latitude: number;
      longitude: number;
    };
    ZOOM_LEVEL: number;
    GEOCODING_BASE_URL: string;
  };
}

export enum Environment {
  DEV = "dev",
  PROD = "prod",
}

// Interface for the config
export interface IEnvConfig {
  env: Environment; // or EnvironmentType if using Option 2
}
